import React, { useState, useCallback, useRef, useEffect } from 'react'
import './styles.css' // Importa o CSS criado acima
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownLeftAndUpRightToCenter,
  faImage,
  faTrash,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons'
import base64 from '../../Base64Geral'
import { Render } from '../render'

interface ImageUploaderProps {
  onImageChange: (file: File | null, base64?: string) => void
  height?: string | number // Agora opcionais com valores default
  width?: string | number
  convertBase64?: boolean
  imagePreview?: string | null
  disableDelete?: boolean
  clear?: Function
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  onImageChange,
  height = '200px',
  width = '100%',
  convertBase64 = false,
  imagePreview = null,
  disableDelete = false,
  clear
}) => {
  const [previewUrl, setPreviewUrl] = useState<string>('')
  const [isDragging, setIsDragging] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const [shrink, setShrink] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false);


  const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    processFile(file)
  }, [])

  // Função auxiliar para processar o arquivo (usada no input e no drop)
  const processFile = async (file: File | undefined) => {
    if (file && file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);

      if (convertBase64) {
        setIsLoading(true);
        try {
          const base64String = await base64(file);
          onImageChange(file, base64String);
        } catch (error) {
          console.error("Erro ao converter para Base64", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        onImageChange(file);
      }
    }
  };

  const handleRemoveImage = useCallback(() => {
    if (previewUrl) URL.revokeObjectURL(previewUrl)
    setPreviewUrl('')
    if (inputRef.current) inputRef.current.value = ''
    onImageChange(null)
    clear()
  }, [previewUrl, onImageChange])

  const handleContainerClick = () => {
    if (!previewUrl && inputRef.current) {
      inputRef.current.click()
    }
  }

  // Eventos de Drag & Drop (opcional, mas melhora a UX)
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = () => setIsDragging(false)
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(false)
    const file = e.dataTransfer.files?.[0]
    processFile(file)
  }

  useEffect(() => {
    if (imagePreview) {
      setPreviewUrl(imagePreview);
    }
  }, [imagePreview]);

  console.log('disableDelete', disableDelete)

  return (
    <div
      className={`uploader-container ${!previewUrl ? 'empty' : ''}`}
      style={{ width, height: shrink ? '100%' : height, borderColor: isDragging ? '#6366f1' : undefined }}
      onClick={handleContainerClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        type='file'
        accept='image/*'
        onChange={handleFileChange}
        ref={inputRef}
        style={{ display: 'none' }}
      />

      {previewUrl ? (
        <>
          <img src={previewUrl} alt='Preview' className='preview-image' />

          <Render condition={disableDelete === false}>
            <button
              className='remove-btn'
              onClick={(e) => {
                e.stopPropagation()
                handleRemoveImage()
                setShrink(false)
              }}
              title='Remover imagem'
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Render>
          <button
            className='maximize-btn'
            onClick={() => {
              setShrink(!shrink)
            }}
          >
            <FontAwesomeIcon
              color='#5da57d'
              icon={shrink ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter}
            />
          </button>
        </>
      ) : (
        <div className='upload-placeholder'>
          {/* Ícone de Upload animado via CSS no hover do pai */}
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>
            <FontAwesomeIcon icon={faImage} />
          </div>
          <span style={{ fontSize: '14px', fontWeight: 500 }}>
            {isDragging ? 'Solte a imagem aqui' : 'Adicionar Imagem'}
          </span>
        </div>
      )}
    </div>
  )
}

export default ImageUploader
